import React, { useCallback, useState } from 'react';
import { ChevronDownIcon, XIcon } from 'lucide-react';
import { useOutsideClick } from '../../hooks/useOutsideClick';
interface SelectProps {
  options: string[];
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  clearable?: boolean;
  onClear?: () => void;
  width?: number;
  fullWidth?: boolean;
  error?: boolean;
  id?: string;
}
export function Select({
  options,
  value,
  placeholder,
  onChange,
  clearable = false,
  onClear,
  width = 180,
  fullWidth = false,
  error = false,
  id
}: SelectProps) {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const ref = useOutsideClick<HTMLDivElement>(close);
  const showClear = clearable;
  return <div ref={ref} className="relative flex items-center gap-1" style={{
    width: fullWidth ? '100%' : width
  }} data-id="element-367" data-mp="2wzmw70yq3f0q">
      <button type="button" id={id} onClick={() => setOpen(v => !v)} aria-expanded={open} aria-haspopup="listbox" className={`flex h-9 w-full items-center justify-between gap-2 rounded-lg border bg-white px-3 text-left text-[13px] ${error ? 'border-red-400' : open ? 'border-brand-500' : 'border-ink-200'} hover:bg-ink-50 ${value ? 'text-ink-800' : 'text-ink-400'}`} data-id="element-368" data-mp="31yzinklomk2s">
        <span className="truncate" data-id="element-369" data-mp="1an2j6uadqfg7">{value || placeholder}</span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 text-ink-400 ${open ? 'rotate-180' : ''}`} data-id="element-370" data-mp="mwge9bvo9baf" />
      </button>
      {showClear && <button type="button" onClick={() => onClear ? onClear() : onChange(placeholder)} aria-label="Clear filter" className="flex h-7 w-7 shrink-0 items-center justify-center rounded border border-ink-300 bg-white text-ink-500 hover:bg-ink-50" data-id="element-371" data-mp="hyev6qy8xbyy">
          <XIcon className="h-3.5 w-3.5" data-id="element-372" data-mp="27dbhqcbkrl4h" />
        </button>}
      {open && <ul role="listbox" className="absolute left-0 top-10 z-30 max-h-72 w-full min-w-[220px] overflow-y-auto rounded-lg border border-brand-500 bg-white py-1 shadow-pop" data-id="element-373" data-mp="239dje3u2qech">
          {options.map(option => <li key={option} data-id="element-374" data-mp="19x6tr2j6vmet">
              <button type="button" role="option" aria-selected={option === value} onClick={() => {
          onChange(option);
          setOpen(false);
        }} className={`block w-full px-3 py-2 text-left text-[13px] hover:bg-ink-50 ${option === value ? 'font-semibold text-brand-700' : 'text-ink-700'}`} data-id="element-375" data-mp="19xyl215r6xza">
                {option}
              </button>
            </li>)}
        </ul>}
    </div>;
}